import type { CatalogSnapshotStatus } from "../../lib/catalog-snapshot-status.js";

export function CatalogSnapshotStatusBanner({ status }: { status: CatalogSnapshotStatus }) {
  const tone = status.demoMarked || status.stale || !status.cartEnabled
    ? "border-amber-200 bg-amber-50 text-amber-950"
    : "border-emerald-200 bg-emerald-50 text-emerald-950";

  return (
    <div className={`rounded-[14px] border px-3 py-2 text-xs ${tone}`} role="status">
      <p className="font-semibold">
        Catalog: {status.sourceLabel}
        {status.stale ? " · STALE" : ""}
        {status.demoMarked ? " · DEMO" : ""}
        {status.cartEnabled ? " · cart OK" : " · read-only"}
      </p>
      {status.lastUpdated ? (
        <p className="mt-0.5 opacity-80">Last updated: {status.lastUpdated}</p>
      ) : null}
      {status.snapshotId ? (
        <p className="mt-0.5 opacity-60">snapshot {status.snapshotId}</p>
      ) : null}
      {status.categoryCount != null || status.productCount != null ? (
        <p className="mt-0.5 opacity-70">
          {status.categoryCount != null ? `${status.categoryCount} categories` : null}
          {status.categoryCount != null && status.productCount != null ? " · " : null}
          {status.productCount != null ? `${status.productCount} products` : null}
          <span className="opacity-50"> (staging)</span>
        </p>
      ) : null}
      {status.demoMarked ? (
        <p className="mt-1 font-medium">Demo snapshot — replace via Prom export builder.</p>
      ) : null}
      {status.stockWarning ? <p className="mt-1">{status.stockWarning}</p> : null}
      <p className="mt-1 opacity-80">{status.checkoutHint}</p>
    </div>
  );
}
